<template>
  <iImageContainer
    v-if="shouldRenderImageContainer"
    :whitespace-style="getOptionValue(ImageFillBackground)"
    :href="builderNoNavHref"
    :target="target"
    :shape="getOptionValue(ImageShape)"
    :show-placeholder="showImagePlaceholder"
    :placeholder-image-src="placeholderImageSrc"
    :width="myWidth"
    :height="myHeight"
    :min-height="getOptionValue(MinHeight)"
    :min-width="getOptionValue(MinWidth)"
    :max-height="getOptionValue(MaxHeight)"
    :max-width="getOptionValue(MaxWidth)"
    :src="imageSrc"
    :alt="imageAltText"
    :fallback-image="fallbackImageSrc"
    :object-position="getOptionValue(ObjectPosition)"
    :style-overrides="imageStyleOverrides"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :border-radius="myBorderRadius"
    :crop-if-needed="myCropIfNeeded"
    :aspect-ratio="myImageAspectRatio"
    :filter-effects="imageFilterEffects"
    :blend-mode="getOptionValue(BlendMode)"
    :rendering="getOptionValue(Rendering)"
  />
</template>

<script>
import { StandardImageElementMixin } from
  "%/dynamic-component-editor/standard-elements/image-element/standard-image-element-mixin";

export default {
  name: "BaseImageElement",
  elementPanelSettings: {
    displayName: "Image",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
  mixins: [StandardImageElementMixin],
  computed: {
    shouldRenderImageContainer() {
      return Boolean(
        this.showImagePlaceholder || this.imageSrc || this.fallbackImageSrc || this.imageMediaUnresolvable,
      );
    },
    showImagePlaceholder() {
      return this.editMode;
    },
    placeholderImageSrc() {
      return undefined;
    },
  },
  watch: {
    myClipPath: {
      handler(value) {
        this.setClipPath(value);
      },
    },
  },
  mounted() {
    this.setClipPath(this.myClipPath);
  },
  methods: {
    setClipPath(value) {
      if (this.$el && this.$el.querySelector && typeof this.$el.querySelector === "function") {
        const image = this.$el?.querySelector("img");
        if (image) {
          image.style.clipPath = value;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(img) {
  clip-path: v-bind(myClipPath) !important;
}
</style>
